// Owner: shell-nav (plan §9.2). The current pathname for shell chrome that layouts render (the top bar
// and its contributed items). The layouts (`AppShell`, `_focus`) provide it from the router, so the
// chrome itself does not depend on router hooks and renders anywhere (tests, stories, screens that
// mock the router); without a provider it falls back to the document's location.
import { useRouterState } from '@tanstack/react-router';
import { type ReactNode, createContext, useContext } from 'react';

const PathnameContext = createContext<string | null>(null);

export function PathnameProvider({ children }: { children: ReactNode }) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return <PathnameContext.Provider value={pathname}>{children}</PathnameContext.Provider>;
}

export function useShellPathname(): string {
  const fromLayout = useContext(PathnameContext);
  if (fromLayout !== null) return fromLayout;
  return typeof window === 'undefined' ? '/' : window.location.pathname;
}
